const keyWords = [
  [
    "“十四五”",
    "今年要编制好“十四五”规划，为开启第二个百年奋斗目标新征程擘画蓝图。"
  ],
  [
    "小康",
    "今年要优先稳就业保民生，坚决打赢脱贫攻坚战，努力实现全面建成小康社会目标任务。"
  ],
  [
    "人类命运共同体",
    "应对公共卫生危机、经济严重衰退等全球性挑战，各国应携手共进。中国将同各国加强防疫合作，促进世界经济稳定，推进全球治理，维护以联合国为核心的国际体系和以国际法为基础的国际秩序，推动构建人类命运共同体。"
  ],
  [
    "发展",
    "只要直面挑战，坚定发展信心，增强发展动力，维护和用好我国发展重要战略机遇期，当前的难关一定能闯过，中国的发展必将充满希望。",
    "中国坚定不移走和平发展道路，在扩大开放中深化与各国友好合作，中国始终是促进世界和平稳定与发展繁荣的重要力量。"
  ],
  [
    "经济",
    "无论是保住就业民生、实现脱贫目标，还是防范化解风险，都要有经济增长支撑，稳定经济运行事关全局。",
    "今年已过去近5个月，下一阶段要毫不放松常态化疫情防控，抓紧做好经济社会发展各项工作。"
  ],
  [
    "三农",
    "支持电商、快递进农村，拓展农村消费。",
    "实行农民工在就业地平等享受就业服务政策。",
    "增加专项债券投入，支持现代农业设施、饮水安全工程和人居环境整治，持续改善农民生产生活条件。"
  ],
  [
    "粮食生产",
    "稳定粮食播种面积和产量，提高复种指数，提高稻谷最低收购价，增加产粮大县奖励，大力防治重大病虫害。惩处违法违规侵占耕地行为，新建高标准农田8000万亩。",
    "14亿中国人的饭碗，我们有能力也务必牢牢端在自己手中。"
  ],
  [
    "食品安全",
    "严格食品药品监管，确保安全。"
  ],
  [
    "农民",
    "拓展农民就业增收渠道。支持农民就近就业创业，扩大以工代赈规模，让返乡农民工能打工、有收入。"
  ],
  [
    "乡村振兴",
    "落实脱贫攻坚和乡村振兴举措，保障重要农产品供给，提高农民生活水平。",
    "接续推进脱贫与乡村振兴有效衔接，全力让脱贫群众迈向富裕。"
  ],
  [
    "环保",
    "提高生态环境治理成效。突出依法、科学、精准治污。"
  ],
  [
    "污染防治",
    "要打好蓝天、碧水、净土保卫战，实现污染防治攻坚战阶段性目标。",
    "污染防治持续推进，主要污染物排放量继续下降，生态环境总体改善。"
  ],
  [
    "就业",
    "城镇新增就业900万人以上，城镇调查失业率6%左右，城镇登记失业率5.5%左右。",
    "保障就业和民生，必须稳住上亿市场主体，尽力帮助企业特别是中小微企业、个体工商户渡过难关。",
    "各地要清理取消对就业的不合理限制，促就业举措要应出尽出，拓岗位办法要能用尽用。"
  ],
  [
    "职业技能",
    "资助以训稳岗，今明两年职业技能培训3500万人次以上，高职院校扩招200万人，要使更多劳动者长技能、好就业。"
  ],
  [
    "新型城镇化",
    "加强新型城镇化建设，大力提升县城公共设施和服务能力，以适应农民日益增加的到县城就业安家需求。",
    "深入推进新型城镇化。发挥中心城市和城市群综合带动作用，培育产业、增加就业。"
  ],
  [
    "生活服务",
    "新开工改造城镇老旧小区3.9万个，支持加装电梯，发展用餐、保洁等多样社区服务。"
  ],
  [
    "双创",
    "深入推进大众创业万众创新。发展创业投资，增加创业担保贷款。深化新一轮全面创新改革试验，新建一批双创示范基地，坚持包容审慎监管，发展平台经济、共享经济，更大激发社会创造力。",
    "大众创业万众创新深入开展，企业数量日均净增1万户以上。"
  ],
  [
    "教育",
    "义务教育学生生活补助人数增加近40%，高职院校扩招100万人。",
    "要优化投入结构，让教育资源惠及所有家庭和孩子，让他们有更光明未来。",
    "推动教育公平发展和质量提升。有序组织中小学教育教学和中高考工作。"
  ],
  [
    "医疗",
    "用好抗疫特别国债，加大疫苗、药物和快速检测技术研发投入，增加防疫救治医疗设施，增加移动实验室，强化应急物资保障，强化基层卫生防疫。"
  ],
  [
    "医保",
    "提高基本医疗服务水平。居民医保人均财政补助标准增加30元，开展门诊费用跨省直接结算试点。"
  ],
  [
    "养老",
    "上调退休人员基本养老金，提高城乡居民基础养老金最低标准。",
    "全国近3亿人领取养老金，必须确保按时足额发放。"
  ],
  [
    "消费",
    "通过稳就业促增收保民生，提高居民消费意愿和能力。支持餐饮、商场、文化、旅游、家政等生活服务业恢复发展，推动线上线下融合。",
    "今年拟安排地方政府专项债券3.75万亿元，比去年增加1.6万亿元，提高专项债券可用作项目资本金的比例，中央预算内投资安排6000亿元。重点支持既促消费惠民生又调结构增后劲的“两新一重”建设。",
    "开展消费扶贫行动，支持扶贫产业恢复发展。"
  ],
  [
    "外贸",
    "围绕支持企业增订单稳岗位保就业，加大信贷投放，扩大出口信用保险覆盖面，降低进出口合规成本，支持出口产品转内销。",
    "加快跨境电商等新业态发展，提升国际货运能力。推进新一轮服务贸易创新发展试点。",
    "筹办好第三届进博会，积极扩大进口，发展更高水平面向世界的大市场。"
  ],
  [
    "智能制造",
    "发展工业互联网，推进智能制造。"
  ],
  [
    "5G",
    "加强新型基础设施建设，发展新一代信息网络，拓展5G应用，建设充电桩，推广新能源汽车，激发新消费需求、助力产业升级。"
  ],
  [
    "科技",
    "提高科技创新支撑能力。稳定支持基础研究和应用基础研究，引导企业增加研发投入。",
    "加快建设国家实验室，重组国家重点实验室体系，发展社会研发机构。深化国际科技合作。加强知识产权保护。"
  ],
  [
    "文化",
    "培育和践行社会主义核心价值观，发展哲学社会科学、新闻出版、广播影视、文物等事业。"
  ],
  [
    "妇女儿童",
    "支持社会组织、人道救助、志愿服务、慈善事业等健康发展。保障妇女、儿童、老人、残疾人合法权益。",
    "发展养老、托幼服务。"
  ],
  [
    "旅游",
    "支持餐饮、商场、文化、旅游、家政等生活服务业恢复发展，推动线上线下融合。"
  ],
  [
    "脱贫攻坚",
    "脱贫是全面建成小康社会必须完成的硬任务，要坚持现行脱贫标准，强化扶贫举措落实，确保剩余贫困人口全部脱贫，健全和执行好返贫人口监测帮扶机制，巩固脱贫成果。",
    "加强易地扶贫搬迁后续扶持。深化东西部扶贫协作和中央单位定点扶贫。强化兜底保障。搞好脱贫攻坚普查。",
    "加大剩余贫困县和贫困村攻坚力度，对外出务工劳动力，要在就业地稳岗就业。"
  ],
  [
    "交通",
    "加强交通、水利等重大工程建设。增加国家铁路建设资本金1000亿元。"
  ],
  [
    "减税降费",
    "今年继续执行下调增值税税率和企业养老保险费率等制度，新增减税降费约5000亿元。",
    "预计全年为企业新增减负超过2.5万亿元。要坚决把减税降费政策落到企业，留得青山，赢得未来。",
    "小微企业、个体工商户所得税缴纳一律延缓到明年。"
  ],
  [
    "冬奥会",
    "加强公共文化服务，筹办北京冬奥会、冬残奥会，倡导全民健身，使全社会充满活力、向上向善。"
  ],
  [
    "国防",
    "深化国防和军队改革，提高后勤和装备保障能力，推动国防科技创新发展。"
  ],
  [
    "生态建设",
    "实施重要生态系统保护和修复重大工程，促进生态文明建设。",
    "严惩非法捕杀和交易野生动物行为。",
    "深化重点地区大气污染治理攻坚。"
  ],
  [
    "“六稳”“六保”",
    "“六保”是今年“六稳”工作的着力点。守住“六保”底线，就能稳住经济基本盘；以保促稳、稳中求进，就能为全面建成小康社会夯实基础。"
  ],
  [
    "抗疫",
    "发行1万亿元抗疫特别国债。",
    "要大幅提升防控能力，坚决防止疫情反弹，坚决守护人民健康。",
    "坚持生命至上，改革疾病预防控制体制，完善传染病直报和预警系统，坚持及时公开透明发布疫情信息。"
  ],
  [
    "财政",
    "今年赤字率拟按3.6%以上安排，财政赤字规模比去年增加1万亿元。"
  ],
  [
    "住房",
    "坚持房子是用来住的、不是用来炒的定位，因城施策，促进房地产市场平稳健康发展。完善便民设施，让城市更宜业宜居。"
  ]
];

// 第一项是匹配的关键词，第二项是物品的分类，第三项是物品的详细名称
// 优先匹配名称，然后匹配分类，
const sorts = [
  [
    "智能制造、消费、小康",
    "家用电器",
    "电视、空调、洗衣机、冰箱、微波炉、厨卫、生活电器、音箱、加湿器、饮水机、电风扇、吸尘器"
  ],
  [
    "消费、住房、小康",
    "家具、家居家装、家居用品、家纺、家装建材、家装饰品、居家摆件、布料、床上用品",
    "各种家具、被子枕头、暖气、凉席、雨伞雨具、窗帘、蚊帐、门、灯具、拖把扫把、毯子、蚊帐、窗帘、樟脑丸、晾衣架"
  ],
  [
    "环保、污染防治、消费",
    "垃圾",
    "垃圾桶、垃圾、纸团、食物残渣"
  ],
  [
    "职业技能、智能制造、交通",
    "五金、机器设备",
    "钳子、扳手、刻刀、螺钉螺母、螺丝刀、改锥、指甲刀"
  ],
  [
    "文化、5G、双创",
    "文艺类、娱乐用品",
    "玩具、手办、网络游戏、手游、玩偶、动漫、动画片、彩色动漫、黑白动漫、游戏、CD包装封面装饰字画、绘画、简笔画、艺术画、相册相框、剪纸、花瓶陶器瓷器、雕塑、香炉、工艺品青铜器、文明遗迹乐器博物馆、展厅博物馆、影剧院礼堂大厅、文明遗迹烟花历史黑白照片、地图、海报、设计图、设计效果图"
  ],
  [
    "外贸、生活服务、消费",
    "洗护用品、个护化妆、口腔护理、护肤品",
    "口腔护理、牙膏牙刷、化妆品、彩妆、美妆、洗发护发、沐浴露 、香皂、肥皂、洗衣粉洗衣液、护手霜、洗面奶、洁具、清洁剂、清洁工具、清洁用品、身体护理发廊"
  ],
  [
    "抗疫、外贸、住房",
    "卫生间、洗手间、厕所",
    "水龙头、花洒、马桶、卷纸、抽纸、卫生用品、公共卫生间"
  ],
  [
    "食品安全、消费、养老",
    "厨具、餐具、调味品",
    "锅碗瓢盆、筷子、勺子、铲子、刀盐、糖、食用油、酱油、醋、香油、料酒"
  ],
  [
    "食品安全、粮食生产、减税降费",
    "食物、餐饮场所",
    "食品、食物、食材、饮料、包装食品主食、米饭、面条、馒头、花卷、烧麦零食、沙拉、火锅、菜品香烟、饮料、饮品、瓶子、水杯、瓶饮、蜂蜜、咖啡、奶茶酒、酒杯、茶、茶叶、茶杯餐饮场所、食堂、餐厅、酒吧歌舞厅、酒店、酒窖"
  ],
  [
    "医保、养老、抗疫",
    "医药相关、药品、保健品、营养滋补",
    "药片、药丸、冲剂、创可贴、保健品、X光照片医院、红十字、救护车、担架、急救箱、针管、绷带、纱布病理、病理图、病毒医疗手术场所、医生、护士"
  ],
  [
    "5G、双创、文化",
    "数码、数码产品、数码产品办公、电子产品、电脑办公、建筑-会议室",
    "电脑、平板电脑、手机、手机配件、耳机、数码相机、摄像机、数码配件、三脚架、云台、读卡器、显示器、硬盘、鼠标、鼠标垫、键盘、U盘、充电器、收音机、录音机、音箱打印机、碎纸机、传真机、扫描设备、收银机、考勤门禁、电子原器件手机、智能手环、耳机、手表、时钟、钟表"
  ],
  [
    "教育、就业、双创",
    "办公室内用具、文具",
    "笔、本册、便签、纸制品、图书、书籍封面、杂志、词典、文件夹、便签、计算器、文房四宝、订书机、起钉器、打孔器、数据线、摄像头、手写板、插座、机顶盒、胶水、黑板白板、剪刀、报纸、期刊、光盘、影碟文具、胶棒、胶水、胶带、胶带座、计算器、尺子、圆规、橡皮、笔筒、笔袋、台历架图书馆"
  ],
  [
    "教育、妇女儿童、就业",
    "教学用品",
    "黑板、投影仪、教案、翻页笔、粉笔、讲台、教学图示学校、宿舍、教室"
  ],
  [
    "消费、就业、小康",
    "衣物、服装",
    "男装、女装、童装、内衣、鞋子"
  ],
  [
    "经济、新型城镇化、财政",
    "建筑",
    "高楼大厦、平房、大桥、仓库标志性建筑、公安局、派出所、商店商场、现代建筑"
  ],
  [
    "交通、旅游、减税降费",
    "交通",
    "交通工具、汽车、自行车、飞机、火车、高铁、船舶、整车、汽车用品公交站牌、地铁站台、红绿灯、人行道、地铁、打卡机、马路、路灯、路牌、斑马线、人行横道、井盖、地下通道、过街天桥、航母、候机候车大厅、地下停车场、地下通道火车票、公交卡"
  ],
  [
    "生态建设、乡村振兴、旅游",
    "自然风景、自然图像",
    "天空、江河湖海、雪花、冰凌、沙滩、大海、沙漠、瀑布、星星、月亮农田、山丘、峡谷、岩石、悬崖卫星云图"
  ],
  [
    "文化、旅游、生态建设",
    "人文景观",
    "寺庙、佛像、亭台楼阁、古建筑"
  ],
  [
    "消费、减税降费、脱贫攻坚",
    "配饰",
    "鞋帽、眼镜、围巾、耳环、耳钉、项链、配饰、首饰"
  ],
  [
    "医疗、冬奥会、小康",
    "人体部位",
    "手、脚、腿、胳膊"
  ],
  [
    "减税降费、就业、抗疫",
    "随身物品",
    "钱包、钱、货币、纸币、硬币、箱包、银行卡、钥匙身份证、卡片、名片"
  ],
  [
    "经济、文化、小康",
    "人物、人物特写、人脸、人物活动",
    "大人、青年、明星"
  ],
  [
    "妇女儿童、教育、小康",
    "人物、人物特写、人脸",
    "小孩、婴儿"
  ],
  [
    "养老、医保、小康",
    "人物、人物特写、人脸",
    "老人"
  ],
  [
    "粮食生产、污染防治、生态建设",
    "植物",
    "花草树木、盆栽、花卉绿植、花束蔬菜水果公园园林、超市菜场"
  ],
  [
    "生态建设、消费、小康",
    "动物、宠物用品",
    "狗、猫、兔子、鸭子、鱼、昆虫、动物、动物园"
  ],
  [
    "冬奥会、文化、教育",
    "体育用品",
    "保健器械、保健用品、保健设备、户外用品、护理护具、运动健康、运动器械、运动户外、健身房、室内体育场馆健身器材、跑步机、瑜伽垫、跳绳、哑铃、乒乓球、羽毛球、篮球、足球、网球、台球、排球、轮滑滑板、棋牌麻将、钓竿"
  ],
  [
    "乡村振兴、农民、生活服务",
    "农业用品、农用物资、农业劳动",
    "锄头、耙子、斧头、化肥、农民"
  ],
  [
    "妇女儿童、教育、小康",
    "母婴用品",
    "孕妇装、孕妇保健品、孕妇营养品、怀孕指导书、胎教指导书、尿布、孕妇浴巾、婴儿枕头、被子、尿垫、婴儿床、婴儿奶粉、婴儿床、婴儿手推车、宝宝餐椅、尿片、奶瓶、学饮杯、吸奶器、奶嘴"
  ],
  [
    "国防、“十四五”、发展",
    "军事",
    "武器、弹药、军人、军装、海陆空迷彩服"
  ],
  [
    "“十四五”、小康、“六稳”“六保”",
    "特殊",
    "天安门、人民大会堂、华表、国旗国徽、党旗党徽、党章、旗帜、各国国旗、普通旗子"
  ],
  [
    "“十四五”、小康、“六稳”“六保”",
    "国家领导人肖像",
    "七常委"
  ]
];

const valueBox = [
  [90, 92, 33],
  [65, 58, 116],
  [65, 60, 112],
  [75, 86, 74],
  [77, 52, 63],
  [95, 73, 94],
  [41, 98, 49],
  [112, 24, 70],
  [95, 73, 94],
  [76, 44, 63]
];
const valueBoxIndexMap = [
  [1, 0, 2],
  [1, 2, 0],
  [1, 2, 0],
  [1, 0, 2],
  [0, 2, 1],
  [0, 2, 1],
  [2, 0, 1],
  [0, 2, 1],
  [0, 2, 1],
  [0, 2, 1]
];

// 根据百度识别结果，匹配合适的关键词，和报告
/**
 * @param name string 识别出来的名称
 * @param type string 识别出来的种类
 * @returns array [{}]
 *  */
function findReport (type, name) {
  let keysOfName = '' // 根据名字找到的关键词
  let keysOfType = '' // 根据类别找到的关键词
  let defaultKeys = '“十四五”、小康、“六稳”“六保”' // 如果都没有找到时，返回的默认数据
  let keys // 最终的关键词
  let result = [0,0,0] // 最终结果

  // console.log(name, type)
  sorts.forEach(item => {
    const sType = item[1].split('、')
    const sName = item[2].split('、')

    // console.log('sName 和 name', sName, name)
    if(sName.includes(name)) keysOfName = item[0]
    if(type.indexOf('-') > -1){
      const types = type.split('-')
      types.forEach(t => {
        // console.log('sType 和 type', sType, t)
        if(sType.includes(t)) keysOfType = item[0]
      })
    } else {
      if(sType.includes(type)) keysOfType = item[0]
    }
  })

  // 优先使用名字精确匹配的数据，不然就是根据类别匹配的数据，都找不到用默认数据
  keys = keysOfName || keysOfType || defaultKeys
  // console.log(`keysOfName: ${keysOfName}, keysOfType: ${keysOfType}`)
  
  // 分割成数组，应该是三个关键词
  keys = keys.split('、')

  // 遍历三个关键词，组装成报告，
  // tittle，关键词
  // content，报告
  // value 得分
  keys.forEach((key, index) => {
    let content = ''

    // 获取内容
    keyWords.forEach(keyword => {
      if(keyword[0] === key) {
        // 找到关键词后，要获取报告，从存在的几个报告里随机挑一个
        content = keyword[ Math.floor(Math.random() * (keyword.length - 1) ) + 1 ]
        // console.log(content)
      }
    })

    result.push({
      title: key,
      content: content,
      value: 0
    })
  })

  // 获取随机数值
  const valueDemoIndex = Math.floor(Math.random() * 10)
  // console.log('valueDemoIndex: ', valueDemoIndex)
  const valueDemo = valueBox[valueDemoIndex]
  const valueIndexDemo = valueBoxIndexMap[valueDemoIndex]
  for (let i=0;i<3;i++) {
    result[3+i].value = Math.floor(valueDemo[i] / 132 * 100)
    
    result[valueIndexDemo[i]] = result[3+i]
  }

  result.length = 3

  return result
}

export {
  // keyWords,
  // sorts,
  findReport
}